/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import { apixHandler } from "../../apix-handler";
import type { BodyType, ErrorType } from "../../apix-handler";
import type { UserInteractionsContract } from ".././models";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const chatMessagesUserInteractionsByDiscussionIdGetV2 = (
  discussionId: number,
  options?: SecondParameter<typeof apixHandler>,
  signal?: AbortSignal,
) => {
  return apixHandler<UserInteractionsContract[]>(
    {
      url: `/apix/v2/ChatMessages/${discussionId}/user-interactions`,
      method: "GET",
      signal,
    },
    options,
  );
};

export const getChatMessagesUserInteractionsByDiscussionIdGetV2QueryKey = (
  discussionId?: number,
) => {
  return [`/apix/v2/ChatMessages/${discussionId}/user-interactions`] as const;
};

export const getChatMessagesUserInteractionsByDiscussionIdGetV2QueryOptions = <
  TData = Awaited<
    ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  discussionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getChatMessagesUserInteractionsByDiscussionIdGetV2QueryKey(discussionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>>
  > = ({ signal }) =>
    chatMessagesUserInteractionsByDiscussionIdGetV2(
      discussionId,
      requestOptions,
      signal,
    );

  return {
    queryKey,
    queryFn,
    enabled: !!discussionId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ChatMessagesUserInteractionsByDiscussionIdGetV2QueryResult =
  NonNullable<
    Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>>
  >;
export type ChatMessagesUserInteractionsByDiscussionIdGetV2QueryError =
  ErrorType<unknown>;

export function useChatMessagesUserInteractionsByDiscussionIdGetV2<
  TData = Awaited<
    ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>
  >,
  TError = ErrorType<unknown>,
>(
  discussionId: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdGetV2>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apixHandler>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions =
    getChatMessagesUserInteractionsByDiscussionIdGetV2QueryOptions(
      discussionId,
      options,
    );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * **Authorization**: `session-based` | `user-bearer`


**Authentication**: `auth0` | `LegacyBearer` | `Session`


**Policy**: `InternalUser`


**Stability Level**: `stable`
 */
export const chatMessagesUserInteractionsByDiscussionIdPutV2 = (
  discussionId: number,
  userInteractionsContract: BodyType<UserInteractionsContract>,
  options?: SecondParameter<typeof apixHandler>,
) => {
  return apixHandler<UserInteractionsContract[]>(
    {
      url: `/apix/v2/ChatMessages/${discussionId}/user-interactions`,
      method: "PUT",
      headers: { "Content-Type": "application/merge-patch+json" },
      data: userInteractionsContract,
    },
    options,
  );
};

export const getChatMessagesUserInteractionsByDiscussionIdPutV2MutationOptions =
  <TError = ErrorType<unknown>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdPutV2>
      >,
      TError,
      { discussionId: number; data: BodyType<UserInteractionsContract> },
      TContext
    >;
    request?: SecondParameter<typeof apixHandler>;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdPutV2>>,
    TError,
    { discussionId: number; data: BodyType<UserInteractionsContract> },
    TContext
  > => {
    const mutationKey = ["chatMessagesUserInteractionsByDiscussionIdPutV2"];
    const { mutation: mutationOptions, request: requestOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, request: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdPutV2>
      >,
      { discussionId: number; data: BodyType<UserInteractionsContract> }
    > = (props) => {
      const { discussionId, data } = props ?? {};

      return chatMessagesUserInteractionsByDiscussionIdPutV2(
        discussionId,
        data,
        requestOptions,
      );
    };

    return { mutationFn, ...mutationOptions };
  };

export type ChatMessagesUserInteractionsByDiscussionIdPutV2MutationResult =
  NonNullable<
    Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdPutV2>>
  >;
export type ChatMessagesUserInteractionsByDiscussionIdPutV2MutationBody =
  BodyType<UserInteractionsContract>;
export type ChatMessagesUserInteractionsByDiscussionIdPutV2MutationError =
  ErrorType<unknown>;

export const useChatMessagesUserInteractionsByDiscussionIdPutV2 = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdPutV2>>,
    TError,
    { discussionId: number; data: BodyType<UserInteractionsContract> },
    TContext
  >;
  request?: SecondParameter<typeof apixHandler>;
}): UseMutationResult<
  Awaited<ReturnType<typeof chatMessagesUserInteractionsByDiscussionIdPutV2>>,
  TError,
  { discussionId: number; data: BodyType<UserInteractionsContract> },
  TContext
> => {
  const mutationOptions =
    getChatMessagesUserInteractionsByDiscussionIdPutV2MutationOptions(options);

  return useMutation(mutationOptions);
};
